import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { IoMdInformationCircleOutline } from "react-icons/io";

import { useConversationContext } from "../../contexts/ConversationContextProvider";
import { useUserContext } from "../../contexts/UserContextProvider";
import { colorsConfig } from "../../config/colorsConfig";
import { SeoTags } from "..";
import { convertUnixTimestampToDateTime } from "../utils/timeStampConversion";

const Notifications = () => {
  const { getNotifications, notificationList, setIsNewNotification } =
    useConversationContext();
  const { currentUserInfo } = useUserContext();
  const [selectedHtml, setSelectedHtml] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleRowClick = (row) => {
    setSelectedHtml(row.body);
    setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    setSelectedHtml("");
  };

  const notificationColumn = [
    {
      name: "Notification title",
      selector: (row) => {
        return row?.title;
      },
      sortable: true,
      grow: 3,
    },
    {
      name: "On web",
      maxWidth: "120px",
      selector: (row) => {
        const receiverDetails = row?.receivers.find(
          (x) => x.receiverId === currentUserInfo?.agentId
        );
        if (receiverDetails?.onWeb === 1) {
          return "Yes";
        } else {
          return "No";
        }
      },
      sortable: true,
    },
    {
      name: "On email",
      maxWidth: "120px",
      selector: (row) => {
        const receiverDetails = row?.receivers.find(
          (x) => x.receiverId === currentUserInfo?.agentId
        );
        if (receiverDetails?.onEmail === 1) {
          return "Yes";
        } else {
          return "No";
        }
      },
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row?.notificationType,
      sortable: true,
    },
    {
      name: "Priority",
      selector: (row) => row?.priority,
      sortable: true,
    },
    {
      name: "Notification Time",
      selector: (row) => convertUnixTimestampToDateTime(row?.timeStamp),
      sortable: true,
    },
  ];

  useEffect(() => {
    getNotifications();
    setIsNewNotification(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="w-full mt-5 mb-10 lg:my-1 space-y-5">
      <SeoTags title="Notifications ‣ WaBM" />

      <div className="w-full space-y-2">
        <h1 className="text-2xl">Notifications</h1>
        <h3>Your WaBM Notifications all at one place.</h3>
        <div className="flex items-center gap-1 text-green-700 font-bold">
          <IoMdInformationCircleOutline className="h-5 w-5 text-green-700" />
          <h3>Click on any row to view detailed notification content</h3>
        </div>
      </div>

      <div className="wbm-card-3 space-y-3">
        <div className="rounded-md overflow-auto">
          <DataTable
            columns={notificationColumn}
            data={notificationList}
            customStyles={TableStyles}
            fixedHeader
            pagination
            onRowClicked={handleRowClick}
            highlightOnHover
            pointerOnHover
            striped
          />
        </div>
      </div>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-2xl relative">
            <h2 className="text-xl font-semibold mb-4 text-gray-800">
              Campaign Details
            </h2>
            <div
              className="text-gray-700 text-sm overflow-y-auto max-h-[60vh]"
              dangerouslySetInnerHTML={{ __html: selectedHtml }}
            />
            <button
              onClick={closePopup}
              className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-all"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </main>
  );
};

export default Notifications;

const TableStyles = {
  rows: {
    style: {},
  },
  headCells: {
    style: {
      backgroundColor: colorsConfig.mediumGrey,
      color: "#FFFFFF",
      fontSize: "0.9rem",
    },
  },
  cells: {
    style: {},
  },
};
